export default __webpack_public_path__ + "static/media/smr-gradbook.94191250.png";